import {
  MODE,
  WeekIdentifier,
  WorkCenterViewModel
} from '../Incrementals.types';
import { UiCommands } from './UiCommands';

export function changeModeCommand(
  this: UiCommands,
  mode: MODE,
  weekId: WeekIdentifier,
  workCenter: WorkCenterViewModel
): void {
  // There should always be a match
  const workCenterWeek = this.uiQueries.getWorkCenterWeek(weekId, workCenter);
  workCenterWeek.mode = mode;
  this.setUiStateTriggerReRender(this.uiState);
}
